import React from "react";

const AppContext = React.createContext({
  loading: false,
});

export default AppContext;
